"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultCoverDisplayOptions = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var DefaultCoverDisplayOptions = exports.DefaultCoverDisplayOptions = {
  sectionHeading: 'Your cover details',
  planOptionsHeading: function planOptionsHeading() {
    return null;
  },
  accordionBehaviour: true,
  petSectionHeading: function petSectionHeading(pet) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "petCoverSectionHeading"
    }, pet.species === 'Dog' ? /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "dog-outline"
    }) : /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "cat-outline"
    }), "Select cover for\xA0", /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, pet.species, " ", /*#__PURE__*/_react["default"].createElement("small", null, "(", pet.breed, ")"))));
  },
  disclaimer: /*#__PURE__*/_react["default"].createElement("ol", {
    type: "1",
    className: "numberedListWithDot"
  }, /*#__PURE__*/_react["default"].createElement("li", null, "In relation to conditions covered by your Policy, examples of Conditions covered can be found under \u2018Cover Details\u2019 table."), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Higher Limits"), " - You may be eligible for a higher limits on some conditions and, if so, this will be specified in your certificate of insurance."), /*#__PURE__*/_react["default"].createElement("li", null, "If a condition exists or occurs before the commencement date of the first policy period or within an applicable waiting period, it may be excluded from cover as a ", /*#__PURE__*/_react["default"].createElement("strong", null, "pre-existing condition"), ". Some conditions are eligible for review after an 18-month period \u2013 refer to your Policy Booklet for more information regarding pre-existing conditions."))
};